/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Your_CountryInputs */



/**
* | output |
* | --- |
* | "Your country" |
*
* @param {Community_Your_CountryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_your_country = /** @type {((inputs?: Community_Your_CountryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Your_CountryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre pays")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tu país")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Seu país")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tuo paese")
	return /** @type {LocalizedString} */ ("Your country")
});